// Re-export individual classes for pattern: import { Attachment } from "@stanterprise/protobuf/testsystem/v1/common"
import { testsystem as commonNS } from '../../../lib/testsystem/v1/common/common';

// Export enum
export type TestStatus = commonNS.v1.common.TestStatus;
export const TestStatus = commonNS.v1.common.TestStatus;

// Export class
export type Attachment = commonNS.v1.common.Attachment;
export const Attachment = commonNS.v1.common.Attachment;
